import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	bannerMessage: {
		id: 'search-ai.3p-banner.message',
		defaultMessage:
			"Not finding what you're looking for? <text>Connect your apps to search deeper and get better answers.</text>",
		description: 'Message shown in the third-party apps connection banner',
	},
	dismissButtonLabel: {
		id: 'search-ai.3p-banner.dismiss-button-label',
		defaultMessage: 'Dismiss',
		description: 'Accessible label for the dismiss button on the third-party banner',
	},
	authorizationSuccess: {
		id: 'search-ai.3p-banner.authorization-success',
		defaultMessage: 'Account connected to {product}.',
		description: 'Success message shown when a third-party app is connected',
	},
	authorizationFail: {
		id: 'search-ai.3p-banner.authorization-fail',
		defaultMessage: 'Failed to connect to {product}.',
		description: 'Error message shown when a third-party app connection fails',
	},
});
